import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { useCallback, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import fileUploadService from '../service/fileUploadService';

function CaptureVideo() {}

export default CaptureVideo;
